import { render, staticRenderFns } from "./WorkPackPartsContainer.vue?vue&type=template&id=750508c4&"
import script from "./WorkPackPartsContainer.vue?vue&type=script&lang=js&"
export * from "./WorkPackPartsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750508c4')) {
      api.createRecord('750508c4', component.options)
    } else {
      api.reload('750508c4', component.options)
    }
    module.hot.accept("./WorkPackPartsContainer.vue?vue&type=template&id=750508c4&", function () {
      api.rerender('750508c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/WorkPackPartsContainer.vue"
export default component.exports